import React from 'react';
import { Camera, Clock, Smartphone, DollarSign } from 'lucide-react';

const CompanyValues: React.FC = () => {
  const values = [
    {
      icon: <Camera className="h-8 w-8 text-blue-600" />,
      title: 'Instant Vehicle Detection',
      description: 'Smart scanning instantly detects vehicle type, records entry, and begins tracking time automatically.',
    },
    {
      icon: <Clock className="h-8 w-8 text-blue-600" />,
      title: 'Real Pricing Rules',
      description: 'Quick scan calculates parking duration based on real pricing rules with transparent digital processing.',
    },
    {
      icon: <Smartphone className="h-8 w-8 text-blue-600" />,
      title: 'Live Dashboard Control',
      description: 'See everything live through the dashboard - every movement recorded, every transaction secured.',
    },
    {
      icon: <DollarSign className="h-8 w-8 text-blue-600" />,
      title: 'Zero Revenue Leakage',
      description: 'Digital payments and automated records mean every rupee is accounted for without disputes or confusion.',
    },
  ];

  return (
    <section id="about" className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="w-full lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              The Future of Parking Management
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Park Hive transforms traditional parking operations into a smooth, intelligent, fully automated workflow. Parking becomes organized instead of chaotic. Customers move forward instead of waiting. Operators act with visibility instead of uncertainty.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {values.map((value, index) => (
                <div key={index} className="flex items-start">
                  <div className="mt-1 mr-4 p-2 bg-blue-100 rounded-lg">
                    {value.icon}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{value.title}</h3>
                    <p className="text-gray-600 text-sm">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="w-full lg:w-1/2 relative">
            <div className="aspect-w-4 aspect-h-3 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://images.pexels.com/photos/1756957/pexels-photo-1756957.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
                alt="Modern parking facility" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg hidden md:block">
              <p className="text-lg font-bold text-gray-900 mb-1">Just Smart Parking</p>
              <p className="text-gray-600">Simplified</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyValues;